import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getCookie } from 'app/common/utils/cookie.util';
import { NFTv2Service } from 'app/services/contract/contracts-services/nft.service';
import { KryptomonsService } from 'app/services/kryptomons/kryptomons.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit {

  wallet: string;

  constructor(
    private router: Router,
    private kryptomonsService: KryptomonsService,
    private nftV2Service: NFTv2Service,
    private userService: UserService,
    private web3Service: Web3Service
  ) {
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.web3Service.getChainId().subscribe((chainID: number) => {
      if ([56, 97].includes(chainID)) this.router.navigate(['migrate-to-polygon'])
    })
  }

  ngOnInit(): void {
    let skipOnboarding: string = getCookie('onboarding');
    // forkJoin([
    //   this.kryptomonsService.getAll(this.wallet),
    //   this.nftV2Service.ownedKryptomons(this.wallet)
    // ])
    this.kryptomonsService.getAll(this.wallet)
      .subscribe(
        res => {
          // if (res[1].length || skipOnboarding == 'done') this.router.navigateByUrl('kryptomons');
          if (res.some(k => !k.isStarter) || skipOnboarding == 'done') this.router.navigateByUrl('kryptomons');
          else {
            let walletMode = getCookie('login');
            if (walletMode === 'magic') this.router.navigateByUrl('onboarding/pick-starter');
            else this.router.navigateByUrl('onboarding');
          }
        }
      );
  }

}
